import axios from 'axios'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {toast} from 'react-toastify'
import {API_URL} from 'src/cms/constants/EndPoint'

export const useGetProductSchema = (params: any) => {
  const {search, page = 1, limit = 10, orderBy, order = 'asc'} = params

  return useQuery(['GET_PRODUCT_SCHEMA', params], async () => {
    const {data} = await axios.get(`${API_URL}/product-scheme`, {
      params: {
        search,
        page,
        limit,
      },
    })
    return data
  })
}

export const useGetProductSchemaById = (id: string) => {
  return useQuery(
    ['GET_PRODUCT_SCHEMA_BY_ID', id],
    async () => {
      const {data} = await axios.get(`${API_URL}/product-scheme/${id}`)
      return data
    },
    {
      enabled: !!id,
    }
  )
}

export const useUpdateProductSchema = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (value: any) => {
      const data = await axios.put(`${API_URL}/product-scheme/update/${value?.id}`, value)
      return data
    },
    {
      onSuccess: (data: any) => {
        if (data?.data?.data?.status) {
          queryClient.invalidateQueries('GET_PRODUCT_SCHEMA')
          queryClient.invalidateQueries('GET_PRODUCT_SCHEMA_BY_ID')
          toast.success(data?.data?.data?.message || 'Product Schema updated successfully')
        }
      },
      onError: (error) => {
        toast.error((error as any)?.data?.message || 'Something went wrong')
      },
    }
  )
}
